// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class UserEmailSignature {
  readonly id: string;
  readonly name: string;
  readonly content: string;
  readonly isDefault: boolean;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.content = data.content === undefined ? '' : data.content;
    this.isDefault = data.isDefault === undefined ? false : data.isDefault;
  }

  static zero(): UserEmailSignature {
    const zeroValues: ExcludeMethodsDeep<UserEmailSignature> = {
      id: NIL_UUID,
      name: '',
      content: '',
      isDefault: false,
    };
    return new UserEmailSignature(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type UserEmailSignatureWireFormat = {
  id: string;
  name: string;
  content: string;
  isDefault: boolean;
};

type NewUserEmailSignatureProps = PartialDeep<UserEmailSignature, { recurseIntoArrays: true }>;
export const NewUserEmailSignature: (props: NewUserEmailSignatureProps) => UserEmailSignature = (
  props,
) => new UserEmailSignature(props);

type NewUserEmailSignatureFromWireFormatProps = PartialDeep<
  UserEmailSignatureWireFormat,
  { recurseIntoArrays: true }
>;
export const NewUserEmailSignatureFromWireFormat: (
  props: NewUserEmailSignatureFromWireFormatProps,
) => UserEmailSignature = (props) => new UserEmailSignature(props);
